import {
	addVoidForLinks,
	hamburger,
	viewPromoButton,
	menuOnMobile,
	profileSubmenu,
	toTop,
} from "./utils";
import eventObject from "./event.js";
import search from "./search";
import dateFilter from "./dateFilter";
import user from "./user";
// import googleAnalytics from "./googleAnalytics";
import runFunctions from "@shop/frontend/web/js/shared/index.js";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";

translator.getLanguages().then(() => {});

const $ = window.jQuery;

search();
$("html").removeClass("no-js");
addVoidForLinks($("a"));
hamburger("js-hamburger", "js-menu");
menuOnMobile();
viewPromoButton();
user();
profileSubmenu();
toTop();
runFunctions();
const isDesktop = window.matchMedia("(min-width: 768px)");

$(document).ready(() => {
	// if (window.gaEnabled) googleAnalytics();

	if (isDesktop.matches && $(".events__text").height() < 185) {
		$(".events__more-btn").hide();
		$(".events__text").addClass("events__text_margin");
	}
});

if ($(".js-date").length) {
	dateFilter();
}

$(".dropdown").ariaDropdown();

eventObject.init();

$(document).on("click", ".js-get-fast-registration", e => {
	const el = $(e.currentTarget);
	e.preventDefault();
	$.each($("[data-toggle=tooltip]"), (i, item) => {
		$(item).tooltip("hide");
	});
	eventObject.getFastRegistration();
	const sum = el
		.parents(".js-order")
		.find(".js-summ")
		.text();
	$(".js-summ-fast").text(sum);
	let action = $("#fast-registration-controller").attr("action");
	const eventId = $(el.parents(".js-order").find(".order__sub-event")).data("event");
	const resultID = action.match(/event_id=\d*/);
	action = action.replace(resultID, `event_id=${eventId}`);
	$("#fast-registration-controller").attr("action", action);
});

$(".js-more-text").on("click", e => {
	const element = $(e.currentTarget);
	if (
		element
			.find("span")
			.text()
			.trim() === "Подробнее"
	) {
		element.parents(".js-short-text").removeClass("short");
		element.find("span").text("Скрыть");
	} else {
		element.parents(".js-short-text").addClass("short");
		element.find("span").text("Подробнее");
	}
});
const trigger = isDesktop.matches ? "hover" : "click";

$('[data-toggle="tooltip"]').tooltip({
	trigger,
	template:
		'<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
});

$(".btn__info-icon").on("show.bs.tooltip", e => {
	if (isDesktop.matches) {
		$.each($("[data-toggle=tooltip]"), (i, item) => {
			if (e.target !== item) {
				$(item).tooltip("hide");
			}
		});
	}
});

$(document).on("click", ".js-hide-other-tooltip", e => {
	$.each($("[data-toggle=tooltip]"), (i, item) => {
		if (!item.classList.contains("js-hide-other-tooltip")) {
			$(item).tooltip("hide");
		}
	});
	e.stopPropagation();
});

$(document).on("click", ".js-order-button", e => {
	const element = $(e.currentTarget);
	const link = element.find(".order__button-link");
	if (!link.hasClass("is-quest")) window.location.assign(link.attr("href"));
});

function responseMenu() {
	$(".menu__sub li.menu__item").appendTo(".menu__list");
	var items = $(".menu__list li.menu__item");
	var max_width = $(".menu__list").width() - $(".menu__dropdown").outerWidth();
	var width = 0;
	var hide_from = 0;
	items.each(function(index) {
		if (width + $(this).outerWidth() > max_width) {
			return false;
		} else {
			hide_from = index;
			width += $(this).outerWidth();
		}
	});
	if (hide_from < items.length - 1) {
		items
			.eq(hide_from)
			.nextAll("li.menu__item")
			.appendTo(".menu__sub");
		$(".menu__dropdown").addClass("active");
	} else {
		$(".menu__dropdown").removeClass("active");
	}
}

$(".menu__dropdown").hover(
	function() {
		$(".menu__sub").show();
	},
	function() {
		$(".menu__sub").hide();
	},
);

if (window.matchMedia("(max-width: 1199px)").matches) {
	responseMenu();
}

$("#js-popup-modal").on("hidden.bs.modal", e => {
	$(e.currentTarget)
		.removeClass("modal_place")
		.removeClass("modal_subscription")
		.removeClass("hide-close");
});

let needClose = true;
$(document).on("hide.bs.modal", ".modal.hide-close", e => {
	if (needClose) {
		e.preventDefault();
	}
});

$(document).on("click", "#js-close-subscription-popup", () => {
	needClose = false;
	$("#js-popup-modal .modal-body").off();
	$("#js-popup-modal.modal_subscription").modal("hide");
});

$("#js-popup-modal .modal__close").on("click", (e) => {
	$("#js-popup-modal").modal('hide');
});

$("#headerAuthLink").on("click", e => {
	redirectToLogin(e);
});

$(".js-toggle-long-text").on("click", e => {
	const $moreBtn = $(e.currentTarget);

	if (isDesktop.matches) {
		$moreBtn.text($moreBtn.text().trim() === "Показать все" ? "Свернуть" : "Показать все");
	} else {
		$moreBtn.text($moreBtn.text().trim() === "Описание" ? "Свернуть" : "Описание");
	}

	$moreBtn
		.toggleClass("active")
		.prev()
		.toggleClass("short");
});

$(".order__button-link").on("click", function(e) {
	if ($(this).hasClass("is-quest")) {
		redirectToLogin(e);
	}
});

function redirectToLogin(event) {
	event.preventDefault();
	const curHref = window.location.href;
	const newHref = `https://tatfil.ru/auth/?back_url=${curHref}`;
	window.location.replace(newHref);
}

$(document).on("click", ".js-hide-additional-info", (e) => {
	const element = $(e.currentTarget);
	const parent = element.parents(".additional-info");
	$(parent).slideUp(300);
});

$(document).on("click", "button[data-bs-dismiss='modal']", (e) => {
	$(".modal").modal("hide");
});
